// Formatting helpers for the Cockpit page. Everything renders in Europe/Berlin.

const TZ = "Europe/Berlin"

const weekdayShort = new Intl.DateTimeFormat("de-DE", { timeZone: TZ, weekday: "short" })
const timeShort = new Intl.DateTimeFormat("de-DE", { timeZone: TZ, hour: "2-digit", minute: "2-digit" })
const dayOfMonth = new Intl.DateTimeFormat("de-DE", { timeZone: TZ, day: "numeric" })
const dateLong = new Intl.DateTimeFormat("de-DE", { timeZone: TZ, weekday: "long", day: "numeric", month: "long" })

/** "Do 09:00" for an ISO instant. */
export function berlinWeekdayTime(iso: string): string {
  const d = new Date(iso)
  return `${weekdayShort.format(d).replace(".", "")} ${timeShort.format(d)}`
}

/** "09:00" for an ISO instant. */
export function berlinTime(iso: string): string {
  return timeShort.format(new Date(iso))
}

/** "Dienstag, 9. September" for an ISO instant. */
export function berlinDateLong(iso: string): string {
  return dateLong.format(new Date(iso))
}

/** "8." for a YYYY-MM-DD date (no timezone shift — the string is already a Berlin date). */
export function dayNumber(isoDate: string): string {
  const [y, m, d] = isoDate.split("-").map(Number)
  return dayOfMonth.format(new Date(Date.UTC(y, m - 1, d, 12)))
}

export const DAY_LABELS = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"]

const CHANNEL_ABBR: Record<string, string> = {
  linkedin: "LI",
  instagram: "IG",
  facebook: "FB",
  twitter: "X",
  x: "X",
  google_business: "GB",
  tiktok: "TT",
  bluesky: "BS",
}

export function channelAbbr(platformKey: string): string {
  return CHANNEL_ABBR[platformKey] ?? platformKey.slice(0, 2).toUpperCase()
}

/** "KW 37" from "2026-W37". */
export function weekLabel(weekIso: string): string {
  const n = Number(weekIso.slice(-2))
  return Number.isFinite(n) ? `KW ${n}` : weekIso
}

export function formatNumber(n: number): string {
  return n.toLocaleString("de-DE")
}

/** "+38 %" / "−4 %" / null. Uses the typographic minus like the design. */
export function formatDelta(pct: number | null): string | null {
  if (pct === null) return null
  if (pct === 0) return "±0 %"
  return pct > 0 ? `+${pct} %` : `−${Math.abs(pct)} %`
}

const SOURCE_LABELS: Record<string, string> = {
  content_upload: "Foto-Post",
  industry_news: "Industry News",
  repurposing_content: "Repurposing",
  pillar_post: "Pillar Post",
  evergreen_content: "Evergreen",
  napkin_wisdom: "Napkin Wisdom",
}

export function sourceLabel(source: string): string {
  return SOURCE_LABELS[source] ?? "Beitrag"
}

export { formatLabel } from "@shared/pillarFormats"
